// IELTS Mock 6 — Listening (very difficult: about Band 8–9)
// Same shape as IELTS_DATA_LISTENING in ../IeltsListening.js (4 parts, 40 questions,
// one audio track that plays once straight through). Recording script:
// client/scripts/ielts-audio/mock6-listeningScript.txt
// Groups with `chooseTwo` share one option list across two question numbers.

// `audioStart` (seconds) is where each Part begins in the track; it comes from
// listeningTimings.json, which generate_neural.py rewrites with the audio.
import TIMINGS from "./listeningTimings.json";

const AUDIO_SRC = "/audio/ielts-mock6-listening.mp3";

const IELTS_MOCK6_LISTENING = {
  title: "IELTS Listening Mock 6",
  sections: [
    {
      id: "s1",
      audioStart: TIMINGS.partStarts[0],
      title: "Section 1: Booking a House Move",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Complete the form below. Write ONE WORD AND/OR A NUMBER for each answer.",
          image: null,
          questions: [
            { id: "q1", text: "Customer name: Eleanor ______", type: "fill_blank", answer: "Llewellyn" },
            { id: "q2", text: "Current address: 14 ______ Mews", type: "fill_blank", answer: "Quarrington" },
            { id: "q3", text: "Moving date: ______ March", type: "fill_blank", answer: ["12", "12th", "twelfth"] },
            { id: "q4", text: "Piano: a grand, made in ______", type: "fill_blank", answer: "1897" },
            { id: "q5", text: "Access problem at new house: a narrow ______", type: "fill_blank", answer: "archway" },
            { id: "q6", text: "Parking permit issued by the ______", type: "fill_blank", answer: "council" },
            { id: "q7", text: "Total value for insurance: £______", type: "fill_blank", answer: ["38500", "38,500", "£38,500", "£38500"] },
            { id: "q8", text: "Company to pack the ______ only", type: "fill_blank", answer: "glassware" },
            { id: "q9", text: "Storage needed for: ______ weeks", type: "fill_blank", answer: ["6", "six"] },
            { id: "q10", text: "Quote reference: ______", type: "fill_blank", answer: ["KT4093", "KT 4093"] },
          ],
        },
      ],
    },

    {
      id: "s2",
      audioStart: TIMINGS.partStarts[1],
      title: "Section 2: Halden Moor Observatory",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Choose the correct letter, A, B, C or D.",
          image: null,
          questions: [
            {
              id: "q11",
              text: "The observatory was paid for by",
              type: "mcq",
              options: [
                "A. a local brewer.",
                "B. a brewer's widow.",
                "C. the university.",
                "D. public donations.",
              ],
              answer: "B",
            },
          ],
        },
        {
          instruction:
            "What does the guide say about each building? Choose FIVE answers from the box A–H.",
          image: "/images/ielts-mock6/observatory_options.svg",
          mapOptions: ["A", "B", "C", "D", "E", "F", "G", "H"],
          questions: [
            { id: "q12", text: "The Great Refractor dome", type: "map", answer: "C" },
            { id: "q13", text: "The Transit House", type: "map", answer: "D" },
            { id: "q14", text: "The Library", type: "map", answer: "A" },
            { id: "q15", text: "The Magnetic Hut", type: "map", answer: "G" },
            { id: "q16", text: "The Keeper's Cottage", type: "map", answer: "F" },
          ],
        },
        {
          instruction: "Questions 17–18: Choose TWO letters, A–E.",
          chooseTwo: true,
          question: "Which TWO facilities are new this year?",
          options: [
            "A. a café",
            "B. a lift to the dome",
            "C. a multilingual audio guide",
            "D. a planetarium",
            "E. a larger car park",
          ],
          answer: ["B", "C"],
          questions: [{ id: "q17" }, { id: "q18" }],
        },
        {
          instruction: "Choose the correct letter, A, B, C or D.",
          image: null,
          questions: [
            {
              id: "q19",
              text: "Evening viewing sessions are cancelled when",
              type: "mcq",
              options: [
                "A. there is heavy cloud.",
                "B. too few people have booked.",
                "C. the wind is too strong.",
                "D. the moon is full.",
              ],
              answer: "C",
            },
            {
              id: "q20",
              text: "The guide's most important advice to visitors is to",
              type: "mcq",
              options: [
                "A. book their tickets online.",
                "B. give their eyes time to adjust to the dark.",
                "C. park in the village.",
                "D. join a guided tour of the Library.",
              ],
              answer: "B",
            },
          ],
        },
      ],
    },

    {
      id: "s3",
      audioStart: TIMINGS.partStarts[2],
      title: "Section 3: Research Project on Electronic Waste",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Choose the correct letter, A, B, C or D.",
          image: null,
          questions: [
            {
              id: "q21",
              text: "Why did the students change their focus from recycling to repair?",
              type: "mcq",
              options: [
                "A. Recycling had already been widely researched.",
                "B. Data on recycling were unavailable.",
                "C. Their tutor recommended the change.",
                "D. Repair cafés were easier to access.",
              ],
              answer: "A",
            },
            {
              id: "q22",
              text: "What was the main problem with the repair café visits?",
              type: "mcq",
              options: [
                "A. The volunteers were unwilling to be interviewed.",
                "B. The cafés did not open often enough.",
                "C. Many of the recordings could not be used.",
                "D. Few visitors' items could be repaired.",
              ],
              answer: "C",
            },
            {
              id: "q23",
              text: "What is Sam's concern about the survey?",
              type: "mcq",
              options: [
                "A. The number of responses was too low.",
                "B. The respondents were not representative.",
                "C. Some of the questions were misleading.",
                "D. It was distributed too late.",
              ],
              answer: "B",
            },
            {
              id: "q24",
              text: "According to the survey, the main reason people repair items is",
              type: "mcq",
              options: [
                "A. to save money.",
                "B. concern for the environment.",
                "C. their sentimental value.",
                "D. curiosity about how they work.",
              ],
              answer: "C",
            },
          ],
        },
        {
          instruction: "Questions 25–26: Choose TWO letters, A–E.",
          chooseTwo: true,
          question: "Which TWO barriers to repair will the students focus on?",
          options: [
            "A. the cost of labour",
            "B. a lack of practical skills",
            "C. warranty rules",
            "D. the unavailability of spare parts",
            "E. batteries that cannot be removed",
          ],
          answer: ["D", "E"],
          questions: [{ id: "q25" }, { id: "q26" }],
        },
        {
          instruction:
            "What do the students say about each source? Choose FOUR answers from the box A–F.",
          image: "/images/ielts-mock6/source_options.svg",
          mapOptions: ["A", "B", "C", "D", "E", "F"],
          questions: [
            { id: "q27", text: "The government report", type: "map", answer: "D" },
            { id: "q28", text: "The manufacturers' association study", type: "map", answer: "C" },
            { id: "q29", text: "Kowalski's book", type: "map", answer: "F" },
            { id: "q30", text: "The Dutch case study", type: "map", answer: "B" },
          ],
        },
      ],
    },

    {
      id: "s4",
      audioStart: TIMINGS.partStarts[3],
      title: "Section 4: Tide-Predicting Machines",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Complete the notes below. Write ONE WORD AND/OR A NUMBER for each answer.",
          image: null,
          questions: [
            { id: "q31", text: "Tides are caused mainly by the pull of the moon and, to a lesser extent, the ______.", type: "fill_blank", answer: "sun" },
            { id: "q32", text: "Each simple, regular wave within a tide is called a ______.", type: "fill_blank", answer: "constituent" },
            { id: "q33", text: "Before machines, calculations were done by clerks known as ______.", type: "fill_blank", answer: "computers" },
            { id: "q34", text: "In Kelvin's machine, a wire passing over ______ added the waves together.", type: "fill_blank", answer: ["pulleys", "pulley"] },
            { id: "q35", text: "A pen drew the tide curve onto a moving roll of ______.", type: "fill_blank", answer: "paper" },
            { id: "q36", text: "The machine later used by Doodson could handle ______ constituents.", type: "fill_blank", answer: ["42", "forty-two"] },
            { id: "q37", text: "Doodson calculated the tides for the ______ landings in 1944.", type: "fill_blank", answer: "Normandy" },
            { id: "q38", text: "The machines had to be ______ regularly.", type: "fill_blank", answer: "oiled" },
            { id: "q39", text: "Predictions are least reliable in shallow ______.", type: "fill_blank", answer: ["estuaries", "estuary"] },
            { id: "q40", text: "Predictions cannot take account of the ______.", type: "fill_blank", answer: "weather" },
          ],
        },
      ],
    },
  ],
};

export default IELTS_MOCK6_LISTENING;
